import React, { useState, useEffect } from "react";
import Header from "../../components/header/Header";
import Inputs from "../../components/inputs/Inputs";
import Input from "../../components/inputs/_Input";
import Button from "../../components/button/Button";
import WelcomeCard from "../../components/login/WelcomeCard";
import useIsMobile from "../main/useIsMobile";
import { ReactComponent as LoginCross } from "../../assets/icons/login/login-cross.svg";
import { ReactComponent as LoginEye } from "../../assets/icons/login/login-close-eye.svg";
import { enqueueSnackbar, closeSnackbar } from "notistack";
import axios from "axios";
import { useNavigate } from "react-router";
import "./SginUp.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import imgParallax from "../../assets/icons/login/3d-rendering-triangle-water.png";
import ParallaxImage from "../../components/ParallaxImage/ParallaxImage";

const SginUp = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const url = new URL(document.location.href);
  let ref_link = url.searchParams.get("ref_link");

  const [form, setForm] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    phone_number: "",
    username: "",
    name: "",
    surname: "",
    country: "",
    city: "",
  });

  const [errors, setErrors] = useState({});
  const [formValid, setFormValid] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const navigate = useNavigate();

  const validateField = (name, value) => {
    let error = "";
    if (!value) {
      error = t("reg.errInputSpace");
    } else {
      switch (name) {
        case "email":
          if (!/^\S+@\S+\.\S+$/.test(value))
            error = t("reg.errIncorrectFormatEmail");
          break;
        case "password":
          if (value.length < 4) error = t("reg.errShortPass");
          break;
        case "confirmPassword":
          if (value !== form.password) error = t("reg.errPassNotMath");
          break;
        case "phone":
          if (!/^\d{10,15}$/.test(value)) error = t("reg.errTell");
          break;
        default:
          if (value.length < 2) error = t("reg.errShortValue");
      }
    }
    return error;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: validateField(name, value) }));
  };

  useEffect(() => {
    const hasErrors = Object.values(errors).some((error) => error);
    const allFilled = Object.values(form).every((value) => value);
    setFormValid(!hasErrors && allFilled);
  }, [errors, form]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (!formValid) return;

    console.log(form);

    axios
      .post(
        `https://api-ru.fynex.cc/api/api/users${
          ref_link ? `?ref_link=${ref_link}` : ""
        }`,
        form
      )
      .then((res) => {
        enqueueSnackbar(t("reg.regGood"), {
          variant: "success",
          action: (key) => (
            <button className="close-button" onClick={() => closeSnackbar(key)}>
              <LoginCross />
            </button>
          ),
        });
        localStorage.setItem("username", form.username);
        localStorage.setItem("userEmail", form.email);
        localStorage.setItem("userName", form.name);
        localStorage.setItem("userSurname", form.surname);
        localStorage.setItem("token", res.data);
        localStorage.setItem("isLoggedIn", true);
        navigate(`../market?symbol=BTCUSDT`, { replace: true });
        window.location.reload()

      })
      .catch((error) => {
        enqueueSnackbar(`${t("landing.err")}: ${error.response.data.detail}`, {
          variant: "error",
          action: (key) => (
            <button className="close-button" onClick={() => closeSnackbar(key)}>
              <LoginCross />
            </button>
          ),
        });
      });
  };

  return (
    <div className="container">
      {/* На мобильном параллакс-картинку вообще не монтируем — она всё равно скрыта версткой, но так не тратим трафик и не вешаем лишние обработчики */}
      {!isMobile && (
        <div className="container-left-image">
          <ParallaxImage
            containerClassName="container"
            imageClassName="left-image"
            src={imgParallax}
            alt="Parallax"
          />
        </div>
      )}
      <div className="SginUp">
        {isMobile && <Header isFixed={true} />}
        <div className="reg-wrapper">
          <div className="reg">
            <WelcomeCard
              text={t("reg.welcome")}
              customClass={isMobile ? undefined : "custom-small"}
            />
            <Inputs>
              <Input
                placeholder={t("reg.email")}
                icon={
                  <LoginCross onClick={() => setForm({ ...form, email: "" })} />
                }
                name="email"
                value={form.email}
                onChange={handleInputChange}
                error={errors.email}
              />
              <Input
                placeholder={t("reg.phone_number")}
                icon={
                  <LoginCross
                    onClick={() => setForm({ ...form, phone_number: "" })}
                  />
                }
                name="phone_number"
                value={form.phone_number}
                onChange={handleInputChange}
                error={errors.phone_number}
              />
              <Input
                placeholder={t("reg.name")}
                icon={
                  <LoginCross onClick={() => setForm({ ...form, name: "" })} />
                }
                name="name"
                value={form.name}
                onChange={handleInputChange}
                error={errors.name}
              />
              <Input
                placeholder={t("reg.surname")}
                icon={
                  <LoginCross
                    onClick={() => setForm({ ...form, surname: "" })}
                  />
                }
                name="surname"
                value={form.surname}
                onChange={handleInputChange}
                error={errors.surname}
              />
              <Input
                placeholder={t("reg.country")}
                icon={
                  <LoginCross
                    onClick={() => setForm({ ...form, country: "" })}
                  />
                }
                name="country"
                value={form.country}
                onChange={handleInputChange}
                error={errors.country}
              />
              <Input
                placeholder={t("reg.city")}
                icon={
                  <LoginCross onClick={() => setForm({ ...form, city: "" })} />
                }
                name="city"
                value={form.city}
                onChange={handleInputChange}
                error={errors.city}
              />
              <Input
                placeholder={t("reg.username")}
                icon={
                  <LoginCross
                    onClick={() => setForm({ ...form, username: "" })}
                  />
                }
                name="username"
                value={form.username}
                onChange={handleInputChange}
                error={errors.username}
              />
              <Input
                placeholder={t("reg.password")}
                icon={
                  <LoginEye onClick={() => setPasswordShown(!passwordShown)} />
                }
                type={passwordShown ? "text" : "password"}
                name="password"
                value={form.password}
                onChange={handleInputChange}
                error={errors.password}
              />
              <Input
                placeholder={t("reg.confirmPassword")}
                icon={<LoginEye />}
                type={passwordShown ? "text" : "password"}
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleInputChange}
                error={errors.confirmPassword}
              />
            </Inputs>
            <div className="action">
              <Button
                text={t("reg.buttonReg")}
                onClick={handleSubmit}
                disabled={!formValid}
              />
              <p>
                {t("reg.haveAcc")}{" "}
                <Link to="/Login">{t("reg.login")}</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SginUp;
